module.exports = __webpack_public_path__ + "assets/img/official-media-modal-layer-2-b8284996.png";